<template>
  <div class="main-mobile-header-button" @click="handleOpen">
    <UserCircleIcon aria-hidden="true" class="main-mobile-header-icon" />
  </div>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useModalsStore } from '@/store/modals'

import { UserCircleIcon } from '@heroicons/vue/24/outline'
import HeaderUserDrawer from './HeaderUserDrawer.vue'

const modalsStore = useModalsStore()

const handleOpen = () => {
  const modalInstance = modalsStore.init(
    'mobile-header-user',
    markRaw(HeaderUserDrawer),
  )
  modalInstance?.open(modalsStore.getZIndex())
}
</script>
